<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <g clip-path="url(#clip0_1_78055)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M-0.00390625 0.640904C-0.00390625 0.285863 0.28391 -0.00195312 0.638951 -0.00195312H3.11148C3.12756 -0.00195312 3.14351 -0.00136231 3.1593 -0.00020121H8.83435C8.84969 -0.00131349 8.86521 -0.00187526 8.88072 -0.00187526H11.3532C11.7083 -0.00187526 11.9961 0.285942 11.9961 0.640982V3.11383C11.9961 4.70748 10.7995 6.02165 9.25572 6.20687C8.87224 7.38047 7.87256 8.27537 6.63895 8.50938V10.7124H8.88072C9.23575 10.7124 9.52358 11.0002 9.52358 11.3553C9.52358 11.7103 9.23575 11.9981 8.88072 11.9981H6.0186C6.01113 11.9984 6.00363 11.9985 5.99609 11.9985C5.98856 11.9985 5.98106 11.9984 5.97359 11.9981H3.11147C2.75644 11.9981 2.46862 11.7103 2.46862 11.3553C2.46862 11.0002 2.75644 10.7124 3.11147 10.7124H5.35324V8.50938C4.11963 8.27537 3.11996 7.38047 2.73644 6.20687C1.1927 6.02165 -0.00390625 4.70748 -0.00390625 3.11383V0.640904ZM2.46863 4.82738V1.28376H1.28181V3.11383C1.28181 3.89811 1.77526 4.56713 2.46863 4.82738ZM9.52358 1.28384V4.82738C10.2169 4.56713 10.7104 3.89811 10.7104 3.11383V1.28384H9.52358Z"
        fill="#211F58"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_78055">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
